export const bezugAnalyse = {
    BezugsAnalyseClass: {
        url: 'BezugAnalyse/jahreswerte',
        defaultSegment: 'BezugAnalyse',
        forceRefresh: false,
        receiveType: 'RECEIVE_BezugsAnalyse_bezugAnalyseReducer'
    },
    BezugsKpiClass: {
        url: 'BezugAnalyse/kpi',
        defaultSegment: 'BezugAnalyse',
        forceRefresh: false,
        receiveType: 'RECEIVE_BezugsKpi_bezugAnalyseReducer'
    }
};
